import { render, staticRenderFns } from "./DigitalCouponCollapse.vue?vue&type=template&id=b9c6cd68&scoped=true"
import script from "./DigitalCouponCollapse.vue?vue&type=script&lang=ts"
export * from "./DigitalCouponCollapse.vue?vue&type=script&lang=ts"
import style0 from "./DigitalCouponCollapse.vue?vue&type=style&index=0&id=b9c6cd68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c6cd68",
  null
  
)

export default component.exports